import { createI18n } from 'vue-i18n'
export { icons } from '@/plugins/i18n/icons'
import { en, de } from './locales'

type MessageSchema = typeof de | typeof en
type SupportedLocals = 'de' | 'en'

const i18n = createI18n<[MessageSchema], SupportedLocals>({
	legacy: false,
	locale: 'de',
	fallbackLocale: 'en',
	fallbackWarn: false,
	messages: {
		de,
		en,
	},
	warnHtmlMessage: false,
})

export { i18n }
